import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  DirectionDataBackInitialization,
  DirectionDataInitialization,
  TaxDataBackInitialization,
  TaxDataInitialization
} from 'src/app/constants/initials.orders';
import { Messages } from 'src/app/constants/messages';
import { NotificationMessageComponent } from 'src/app/dialogs/notification-message/notification-message.component';
import { TypeIcon } from 'src/app/model/device/message.model';
import {
  Visualization,
  VisualizationParams, VisualizationParamsFromDefault,
  VisualizationParamsFromDetailOrdersList,
  VisualizationParamsFromPendingOrders
} from 'src/app/model/local/detail.orders.model';
import { PaymentInformation } from 'src/app/model/local/payment.model';
import { DialogService } from 'src/app/services/dialog.service';
import { v4 as uuidv4 } from 'uuid';
import {
  BooleanCons,
  ContentEmpty,
  deliveryType,
  HttpStatus,
  legendByPricesUpdated,
  legendBySubjectPrices,
  LegendsProfileTabs,
  MessageType,
  NumberCons,
  OmicronLabDirection,
  PaymentTypeInfo,
  PaymentTypeInfoCompare,
  RoutesCons,
  StatusPendingOrder,
  StringConst,
  TaxDirection,
  TypeClients
} from '../../constants/const';
import { AutorizeOrder } from '../../model/http/detail.model';
import {
  BackIProductDetailResponse,
  BackIProductDetailStorage,
  DetailUser,
  IProductDetailResponse,
  OrderHeader
} from '../../model/http/historyOrders.model';
import { CallPlace, CallPlaceCompare, IProducts, ProductAttributes } from '../../model/http/myActivity.model';
import { DeliveredDirections, TaxData } from '../../model/http/profile.model';
import {
  CartContentType,
  CartContentTypeCompare
} from '../../model/http/shoppingList';
import {
  CloseDetailOrderData,
  TotalDescriptionShopping
} from '../../model/local/general.model';
import { CalculationService } from '../../services/calculation.service';
import { CommonService } from '../../services/common.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { MyProductsService } from '../../services/my-products.service';
import { MultiContainerProducsMock } from 'src/mocks/multicontainerProductMock';
import { MaskService } from 'src/app/services/mask.service';
import { Alignment, Content, ContentTable, TableCell, TDocumentDefinitions } from 'pdfmake/interfaces';
import { Base64Logo } from 'src/app/constants/logo';
import { PdfService } from 'src/app/services/pdf.service';
import { invoiceType } from '../../constants/const';
import { NumberNotRoundPipe } from 'src/app/pipes/numberNotRound/number-not-round.pipe';
@Component({
  selector: 'app-detail-orders-list',
  templateUrl: './detail-orders-list.component.html',
  styleUrls: ['./detail-orders-list.component.scss'],
})
export class DetailOrdersListComponent implements OnInit {
  totalProducts = 0;
  totalPieces = 0;
  totalDescription = new TotalDescriptionShopping();
  itemsShoppingCard: DetailUser[] = [];
  header = new OrderHeader();
  contentEmpty = ContentEmpty.DetailOrdersListEdit;
  backIProductDetailStorage = new BackIProductDetailStorage();
  cardCode = StringConst.empty;
  taxData: TaxData = TaxDataInitialization;
  directionData: DeliveredDirections = DirectionDataInitialization;
  taxDataBack: TaxData = TaxDataBackInitialization;
  directionDataBack: DeliveredDirections = DirectionDataBackInitialization;
  legendsProfileTabs = LegendsProfileTabs;
  rol = StringConst.empty;
  createName = StringConst.empty;
  legendByPricesUpdated = legendByPricesUpdated;
  legendBySubjectPrices = legendBySubjectPrices;
  statusPendingOrder = StatusPendingOrder;
  cartContentType = CartContentType.default;
  cartContentTypeCompare = CartContentTypeCompare;
  paymentInformation = new PaymentInformation();
  @Input() showFavoriteButton = BooleanCons.true;
  @Input() docNum = StringConst.empty;
  @Input() stringOrderId = StringConst.empty;
  @Input() historyOrdersTiD = StringConst.empty;
  @Input() whoRequest: CallPlace = CallPlace.default;
  @Input() dataObjectParams = new BackIProductDetailResponse();
  @Input() keyStorage = StringConst.empty;
  @Input() isAuthorizeOrder = BooleanCons.false;
  @Input() statusOrder = StringConst.empty;
  @Input() isPaymentProcessed = BooleanCons.false;
  @Output() closeDialog = new EventEmitter<CloseDetailOrderData>();
  @Output() closeDialogEmpty = new EventEmitter<void>();
  visualParams = new VisualizationParams();
  callFromPendingOrders = CallPlace.pendingOrders;
  CallPlacesCompare = CallPlaceCompare;
  paymentTypeCompare = PaymentTypeInfoCompare;
  paymentInfoImage = StringConst.empty;
  isInstitutional = BooleanCons.false;
  shipingCostDiscount = BooleanCons.true;
  shipingCostDiscountAmount = NumberCons.zero;
  promotionalCode = StringConst.empty;
  tooltip = Messages.invoiceInformationIcon;
  invoiceType = invoiceType;
  deliveryType = deliveryType;
  constructor(
    private productService: MyProductsService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private calculationService: CalculationService,
    private dialogService: DialogService,
    private maskService: MaskService,
    private pdfService: PdfService
  ) { }
  ngOnInit(): void {
    this.cardCode = this.localStorageService.getCardCodeGeneral();
    this.rol = this.localStorageService.getUserInRole();
    this.isInstitutional = this.localStorageService.getClientType()
      === TypeClients.institucional;
    this.getVisualizationParams();
    this.callService();
  }
  callService(): void {
    const isProductDetail = this.commonService.validateOrValueList(
      [this.whoRequest === CallPlace.detailOrderList,
      this.whoRequest === CallPlace.activeOrders]);
    if (isProductDetail) {
      this.totalDescription.fromCalled = this.whoRequest;
      this.getProductDetail(this.docNum);
    } else if (this.whoRequest === CallPlace.pendingOrders) {
      this.totalDescription.fromCalled = CallPlace.pendingOrders;
      this.getProductDetailPending(this.stringOrderId);
    }
  }

  afterGetInfo(res: IProductDetailResponse): void {
    if (res.code !== 200) {
      return this.validateError(res.userError);
    }
    this.asignateResponseProductDetail(res);
  }
  validateError(userError: any): void {
    this.launchControlledError(userError);
    this.closeDialogEmpty.emit();
    return;
  }
  getVisualizationParams(): void {
    const optionsDict: { [key: number]: Visualization } = {
      4: new VisualizationParamsFromDetailOrdersList(),
      35: new VisualizationParamsFromPendingOrders(this.rol),
      19: new VisualizationParamsFromDetailOrdersList(),
      [CallPlaceCompare.metricsPromotion]: new VisualizationParamsFromDetailOrdersList(),
    };
    const optionSelected =
      optionsDict[this.whoRequest] ??
      new VisualizationParamsFromDefault(
        this.cardCode === this.backIProductDetailStorage.cardCode
      );
    this.visualParams = optionSelected.getVisualizationParams();
  }
  insertValuesDeliveryAHeader(): void {
    this.header.address = this.header.deliveryAddress?.split('# ');
    this.header.invoiceAddressList = this.header.invoiceAddress?.split('# ');
  }
  asignateResponseProductDetail(res: IProductDetailResponse): void {
    this.itemsShoppingCard = res.response.details ?? [];
    const orderHeader = res.response?.orderHeader ?? new OrderHeader();
    this.totalProducts = orderHeader.totalProducts;
    this.totalPieces = orderHeader.totalPieces;
    this.promotionalCode = orderHeader.promotionalCode;
    this.header = orderHeader;
    this.visualParams.isNeedDataTax = this.header.needTaxData;
    const shippingCost = this.header.shippingCost;
    this.visualParams.isShippingCost = Boolean(this.header.storePickup);
    this.totalDescription.shippingCostDiscountPercent = this.calculationService.calculatePercentageOf(
      this.header.shippingCost,
      this.header.shippingCostDiscount
    );
    this.shipingCostDiscount = this.commonService.validateAndValue(
        [this.header.shippingCost !== this.header.shippingCostDiscount]
      );
    this.shipingCostDiscountAmount = this.commonService.calculatePriceWithDiscount(
      shippingCost, this.totalDescription.shippingCostDiscountPercent
    );
    this.totalDescription.promotionalCodeAmount = orderHeader.promotionalCodeAmount;
    this.totalDescription = this.calculationService.updateTotalDescriptionCalculated(
      this.totalDescription,
      {
        generalTax: orderHeader.iva ?? NumberCons.zero,
        subTotal: orderHeader.subTotal,
        totalPices: this.totalPieces,
        totalProducts: this.totalProducts,
        costShipping: shippingCost,
        totaldiscount: orderHeader.discount,
        totalUtilities: orderHeader.totalUtilities ?? orderHeader.totalOfUtilities,
      }
    );
    const isProductDetail = this.commonService.validateOrValue(
      this.whoRequest === CallPlace.detailOrderList,
      this.whoRequest === CallPlace.activeOrders);
    this.totalDescription.total = this.commonService.calculateTernary(
      isProductDetail,
      this.totalDescription.total + orderHeader.creditNoteAmount,
      this.totalDescription.total
    );
    const totalSpecialDiscount = this.calculationService.getDiscountTotal(
      this.totalDescription.total,
      orderHeader.percentDiscountSpecial
    );
    this.totalDescription.subtotal = this.commonService.calculateTernary(
      isProductDetail,
      this.totalDescription.subtotal + orderHeader.creditNoteAmount,
      this.totalDescription.subtotal
    );
    this.totalDescription.discountSpecial = totalSpecialDiscount;
    this.totalDescription.hasDiscountSpecial = orderHeader.hasDiscountSpecial;
    this.totalDescription.percentDiscountSpecial = orderHeader.percentDiscountSpecial;
    this.totalDescription.totalWithSpecialDiscount = this.totalDescription.total - totalSpecialDiscount;
    this.paymentInformation = res.response?.paymentMethod ?? new PaymentInformation();
    this.totalDescription.hasFavorBalance = orderHeader.creditNoteAmount > 0;
    this.totalDescription.favorBalance = orderHeader.creditNoteAmount;
    this.setbrandPayment();
    this.insertValuesDeliveryAHeader();
    this.totalDescription.isFromDetailOrders = true;
    this.gotoTop();
    this.visualParams.informationIsloaded = BooleanCons.true;
    const id = this.commonService.calculateTernary(
      this.commonService.validateValidString(this.stringOrderId),
      this.stringOrderId,
      this.docNum
    );
    this.header.transactionID = id;
    this.header.transactionId = id;
    if (this.whoRequest === CallPlace.pendingOrders) {
      this.header.transactionId = this.header.transactionIdAuthorized ?? '';
      this.header.transactionID = this.header.transactionIdAuthorized ?? '';
    }
    this.createName = this.header.createName ?? '';
    this.visualParams.isPaymentAuthorized = !Boolean(
      this.header.isPaymentAuthorized
    );
    this.totalDescription.isAuthorizeOrderButton =
      this.visualParams.isPaymentAuthorized;
    this.totalDescription.needsRecipe = this.header.needsRecipe;
    this.totalDescription.isRecipeAuthorized = this.header.isRecipeAuthorized;
    this.validateCartContentType();
  }
  getProductDetail(docNum: string): void {
    this.productService.getProductDetail(this.getQueryParams(docNum)).subscribe(
      (res) => this.asignateResponseProductDetail(res));
  }

  getQueryParams(docNum: string): string {
    const specialityByRol: { [key: string]: string } = {
      doctor: this.localStorageService.getHeaderInfo().groupName,
      advisor: this.localStorageService.getClientDoctor().speciality,
    };
    const specialty = specialityByRol[this.rol];
    return `?dxptransactionid=${docNum}&specialityDoctor=${specialty}${this.commonService.calculateTernary(
      this.whoRequest === CallPlace.activeOrders || this.whoRequest === CallPlace.metricsPromotion, '&needUtilities=true', ''
    )
      }`;
  }

  getAllProducts(): IProducts[] {
    return this.itemsShoppingCard.reduce<IProducts[]>((list, element) => list.concat(element.detailsProducts), []);
  }

  validateCartContentType(): void {
    this.cartContentType = this.commonService.validateCartContentType(this.getAllProducts());
    this.totalDescription.cartContentType = this.cartContentType;
  }
  getProductDetailPending(stringOrderId: string): void {
    const specialityByRol: { [key: string]: string } = {
      doctor: this.localStorageService.getHeaderInfo().groupName,
      advisor: this.localStorageService.getClientDoctor().speciality,
    };
    const req = new AutorizeOrder();
    req.needAuthorized = this.isAuthorizeOrder;
    req.transaction = stringOrderId;
    req.cardCode = this.localStorageService.getCardCodeGeneral();
    req.specialityDoctor = specialityByRol[this.rol];
    req.priceListId = this.localStorageService.getPriceList();
    this.productService.getPendingProductsDetail(req).subscribe(
      (res) => {
        if (res.code === HttpStatus.badRequest) {
          this.launchControlledError(Messages.orderAlreadyCompleted);
          this.closeDialogEmpty.emit();
          return;
        }
        this.validateCartContentType();
        this.afterGetInfo(res);
      },
      () => {
        this.launchControlledError(Messages.orderAlreadyCompleted);
        this.closeDialogEmpty.emit();
      }
    );
  }
  setbrandPayment(): void {
    this.paymentInfoImage = this.commonService.getPaymentMethodIcon(this.paymentInformation.object,
      this.paymentInformation.brand,
      this.paymentInformation.type);
  }
  gotoTop(): void {
    this.commonService.goToSpecificElementRef(
      document,
      'startScrollDetailOrderListDialog'
    );
  }
  editBuyOrder(editBuyOrder: boolean): void {
    this.generateDialogClose(CallPlace.detailOrderList);
    this.keyStorage = uuidv4();
    const backIProductDetailResponse = this.submitOkContinue(
      CallPlace.detailOrderListEdit,
      CallPlace.detailOrderList
    );
    const submit = this.commonService.updateDetailOrderDataEditStorage(
      0,
      0,
      0,
      0,
      backIProductDetailResponse,
      StringConst.empty
    );
    this.localStorageService.setDetailOrderDataEdit(submit, this.keyStorage);
    this.router.navigate([RoutesCons.editBuyOrder, this.keyStorage]);
  }
  acceptButton(close: boolean): void {
    this.generateDialogClose(this.whoRequest);
  }
  generateDialogClose(place: CallPlace): void {
    const closeSubmit = new CloseDetailOrderData();
    closeSubmit.callPlace = place;
    closeSubmit.isAuthorized = BooleanCons.false;
    this.closeDialog.emit(closeSubmit);
  }

  submitOkContinue(
    place: CallPlace,
    startingPlace: CallPlace
  ): BackIProductDetailResponse {
    const backIProductDetailResponse = new BackIProductDetailResponse();
    backIProductDetailResponse.place = place;
    backIProductDetailResponse.docNum = this.docNum;
    backIProductDetailResponse.startingPlace = startingPlace;
    backIProductDetailResponse.keyStorage = this.keyStorage;
    backIProductDetailResponse.rol = this.localStorageService.getUserInRole();
    return backIProductDetailResponse;
  }

  launchControlledError(message?: string): void {
    const text = this.commonService.calculateTernary(
      message !== undefined,
      message,
      Messages.generic
    );
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      typeIcon: TypeIcon.error,
      textToShow: text,
      isButtonCancel: false,
      typeMessage: MessageType.none,
    });
  }

  getDirection(): string[] {
    const isStorePickup = this.header.storePickup === 0;
    return this.commonService.calculateTernary(isStorePickup, OmicronLabDirection, this.header.address ?? []);
  }

  getTaxDirection(): string[] {
    const taxData = this.header.invoiceAddressList ?? [];
    return this.commonService.calculateTernary(this.header.needTaxData, taxData, TaxDirection);
  }

  generatePDF(): void {
    const docDefinition: TDocumentDefinitions = {
      pageSize: 'A4',
      pageMargins: [10, 40, 10, 20],
      defaultStyle: {
        fontSize: 9,
        font: 'FrutigerNext'
      },
      header: (currentPage: number, pageCount: number) => this.getHeader(currentPage, pageCount),
      footer: (currentPage: number, pageCount: number) => this.getFooter(currentPage, pageCount),
      content: [
        this.getHeaderPage(),
        this.getOrderDetail(),
        this.getTitleSection('Dirección de entrega:'),
        {
          ul: [...this.getDirection()],
          margin: [5, 0, 0, 20]
        },
        this.getTitleSection('Datos fiscales:'),
        {
          ul: [...this.getTaxDirection()],
          margin: [5, 0, 0, 20]
        },
        this.getTitleSection('Método de pago:'),
        {
          ul: [this.getPaymentTypePDF()],
          margin: [5, 0, 0, 20]
        },
        this.getTableProducts(),
        {
          text: 'a',
          color: 'white',
          margin: [0, 0, 0, 0]
        },
      ],
    };

    this.pdfService.createPdfAndOpen(docDefinition);
  }

  getPaymentTypePDF(): string {
    let cardNumbers = StringConst.empty;

    if (this.paymentInformation.object === PaymentTypeInfo.card) {
      cardNumbers = this.paymentInformation.brand.toUpperCase() + ' ' +
        this.maskService.maskCardNumber(this.paymentInformation.cardLastNumbers, this.paymentInformation.brand);
    }

    const dictOptions: { [key: string]: string } = {
      cash_payment: 'OXXO',
      card_payment: cardNumbers,
      bank_transfer_payment: 'SPEI',
      credit_payment: 'Crédito',
      paypal: 'Paypal',
      bbvamulti: 'Multipagos BBVA',
      '': '',
    };

    return (dictOptions[this.paymentInformation.object] ?? StringConst.empty) + this.getMsiPlanPDF();
  }

  getMsiPlanPDF(): string {
    const months = this.paymentInformation.monthlyInstallments;
    const amount = this.paymentInformation.monthlyAmount;
    if (this.paymentInformation.object !== PaymentTypeInfo.card || !months) {
      return StringConst.empty;
    }
    const monthly = amount ? ` ($${this.formatMoney(amount)}/mes)` : StringConst.empty;
    return ` · ${months} meses sin intereses${monthly}`;
  }

  private formatMoney(value: number): string {
    return new NumberNotRoundPipe().transform(value);
  }

  getHeader(currentPage: number, pageCount: number): any {
    const headerOptions = [{
      text: `Página ${currentPage} de ${pageCount}`,
      alignment: 'right',
      margin: [0, 17, 10, 0]
    },
    {
      text: `Fecha: ${new Date().toLocaleDateString()}`,
      alignment: 'right',
      margin: [0, 0, 10, 0]
    }
    ];

    return this.commonService.calculateTernary(currentPage === 1, headerOptions, headerOptions.slice(0, 1));
  }

  getDiscountLegend(): string {
    return this.commonService.calculateTernary(this.header.promotionalCodeAmount > 0,
      `Código promocional: ${this.formatPrice(this.header.promotionalCodeAmount)}`,
      `Descuento: ${this.formatPrice(this.header.discount)}`);
  }

  getFooter(currentPage: number, pageCount: number): any {
    if (currentPage === pageCount) {
      return {
        absolutePosition: { x: 0, y: (this.getMarginBottom() * -1) },
        stack: [
          {
            margin: [10, 0],
            table: {
              widths: ['70%', '30%'],
              body: [
                [
                  { text: `Total de productos: ${this.header.totalProducts}`, bold: true, alignment: 'left' },
                  { text: `Subtotal: ${this.formatPrice(this.header.subTotal)}`, bold: true, alignment: 'right' },
                ],
                [
                  { text: `Total de piezas: ${this.header.totalPieces}`, bold: true, alignment: 'left' },
                  { text: `Costo de envío: ${this.formatPrice(this.header.shippingCost)}`, bold: true, alignment: 'right' },
                ],
                [
                  { text: '' },
                  { text: this.getDiscountLegend(), bold: true, alignment: 'right' },
                ],
                [
                  { text: '' },
                  { text: `IVA: ${this.formatPrice(this.header.iva ?? 0)}`, bold: true, alignment: 'right' },
                ],
                ...this.getTotalAndSpecialDiscount()
              ]
            },
            layout: 'noBorders',
            style: {
              fontSize: 12
            },
          }
        ]
      };
    }
    return null;
  }

  getMarginBottom(): number {
    return 85 + 20 * (+this.totalDescription.hasDiscountSpecial + +this.totalDescription.hasFavorBalance);
  }

  getTotalAndSpecialDiscount(): any[] {
    const total = this.commonService.calculateTernary(this.totalDescription.hasDiscountSpecial,
      this.totalDescription.totalWithSpecialDiscount - this.totalDescription.favorBalance,
      this.totalDescription.total - this.totalDescription.favorBalance);

    const data = [];
    if (this.totalDescription.hasDiscountSpecial) {
      data.push(
        [
          { text: '' },
          { text: `Descuento esp: ${this.formatPrice(this.totalDescription.discountSpecial)}`, bold: true, alignment: 'right' },
        ]
      );
    }

    if (this.totalDescription.hasFavorBalance) {
      data.push(
        [
          { text: '' },
          { text: `Saldo a favor: ${this.formatPrice(this.totalDescription.favorBalance)}`, bold: true, alignment: 'right' },
        ]
      );
    }

    data.push(
      [
        { text: '' },
        {
          text: `Total: ${this.formatPrice(total)}`,
          bold: true,
          alignment: 'right',
          fillColor: '#0070b7',
          color: 'white',
          marginTop: 3,
          marginBottom: 3
        },
      ]);
    return data;
  }

  getDoctorName(): string {
    return this.commonService.calculateTernary(
      this.commonService.validateActiveRols().isDoctor,
      this.localStorageService.getHeaderInfo().doctorName,
      this.localStorageService.getClientDoctor().name
    );

  }
  getSpecialty(): string {
    return this.commonService.calculateTernary(
      this.commonService.validateActiveRols().isDoctor,
      this.localStorageService.getHeaderInfo().groupName,
      this.localStorageService.getClientDoctor().speciality
    );
  }
  getHeaderPage(): Content {
    return {
      table: {
        widths: ['50%', '50%'],
        body: [
          [
            {
              stack: [
                {
                  image: Base64Logo,
                  width: 230,
                  height: 45,
                  marginLeft: 30
                },
                {
                  canvas: [
                    {
                      type: 'line',
                      x1: 0,
                      y1: 0,
                      x2: 290,
                      y2: 0,
                      lineWidth: 3,
                      lineColor: '#0070b7'
                    }
                  ],
                  margin: [0, 5, 0, 5]
                }
              ]
            },
            {
              text: ''
            }
          ],
          [
            {
              text: 'OmicronLab S.A de C.V.',
              bold: true
            },
            {
              text: `Dr. ${this.getDoctorName()}`,
              bold: true
            }
          ],
          [
            {
              text: 'Del Refugio 4120, Alfareros, 64753',
              bold: true
            },
            {
              text: this.getSpecialty(),
              bold: true
            }
          ],
          [
            {
              text: 'Monterrey, N.L.',
              bold: true
            },
            {
              text: '',
              bold: true
            }
          ],
          [
            {
              text: 'Tel: 8115222896',
              bold: true
            },
            {
              text: '',
              bold: true
            }
          ]
        ]
      },
      layout: 'noBorders',
      margin: [0, 0, 0, 0]
    };
  }

  getOrderDetail(): Content {
    return {
      text: `Detalle del pedido: #${this.header.transactionId?.toUpperCase()}`,
      alignment: 'left',
      margin: [0, 20, 0, 10],
      bold: true,
    };
  }

  getTitleSection(title: string): Content {
    return {
      text: title,
      alignment: 'left',
      bold: true,
    };
  }

  getTableProducts(): Content {
    return {
      table: {
        headerRows: 1,
        widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto'],
        body: [
          [
            { text: 'Nombre', fillColor: '#332F2E', color: 'white', bold: true, alignment: 'center' },
            { text: 'Producto', fillColor: '#332F2E', color: 'white', bold: true, alignment: 'center' },
            { text: 'Descripción', fillColor: '#332F2E', color: 'white', bold: true },
            { text: 'Costo', fillColor: '#332F2E', color: 'white', bold: true, alignment: 'center' },
            { text: 'Costo con descuento', fillColor: '#332F2E', color: 'white', bold: true, alignment: 'center' },
            { text: 'Cantidad', fillColor: '#332F2E', color: 'white', bold: true, alignment: 'center' },
            { text: 'Total', fillColor: '#332F2E', color: 'white', bold: true, alignment: 'center' },
          ],
          ...this.getTableData()
        ]
      },
      layout: {
        hLineColor: (i: number, node: any) => '#332F2E',
        vLineColor: (i: number, node: any) => '#332F2E',
        hLineWidth: (i: number, node: any) => 0.5,
        vLineWidth: (i: number, node: any) => 0.5,
        paddingLeft: (i: number, node: any) => 4,
        paddingRight: (i: number, node: any) => 4,
        paddingTop: (i: number, node: any) => 5,
        paddingBottom: (i: number, node: any) => 5,
        fillColor: (rowIndex: number, node: ContentTable, columnIndex: number) => {
          const par = rowIndex % 2 === 0;
          return this.commonService.calculateTernary(par, 'white', 'white');
        }
      },
      margin: [0, 0, 0, this.getMarginBottom()]
    };
  }

  formatPrice(price: number = 0): string {
    return price.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).replace('MXN', '');
  }

  getTableData(): TableCell[][] {
    const data: TableCell[][] = [];
    this.itemsShoppingCard.forEach(recipe => {
      const recipePatient = recipe.clientName;
      recipe.detailsProducts.forEach(product => {
        const attributesGroupedByPriceDiscount = this.groupBy(product.productAttributes);
        const keys = Object.keys(attributesGroupedByPriceDiscount);
        const decimalTax = this.calculationService.getTaxRateValue(product.taxRate);
        keys.forEach(key => {
          let labelsconcat = StringConst.empty;
          if (keys.length > 1) {
            labelsconcat = ` / ${attributesGroupedByPriceDiscount[key].map(x => x.label)[0]}`;
          }
          const tax = decimalTax * attributesGroupedByPriceDiscount[key][0].costPerPiece;
          const discounTax = decimalTax * attributesGroupedByPriceDiscount[key][0].costPerPieceDiscount;

          const costPerPiece = this.formatPrice(attributesGroupedByPriceDiscount[key][0].costPerPiece + tax);
          const costPerPieceDiscount = this.formatPrice(attributesGroupedByPriceDiscount[key][0].costPerPieceDiscount + discounTax);
          const totalPieces = attributesGroupedByPriceDiscount[key].reduce((total, attribute) => total + attribute.quantity, 0);
          const grandTotal = this.formatPrice((attributesGroupedByPriceDiscount[key][0].costPerPieceDiscount *
            (decimalTax + 1))  * totalPieces);
          const tableRow = [
            this.getRowFormat(recipePatient, 'left', true),
            this.getRowFormat(product.itemCode),
            this.getRowFormat(product.description + labelsconcat),
            this.getRowFormat(costPerPiece, 'center'),
            this.getRowFormat(costPerPieceDiscount, 'center'),
            this.getRowFormat(totalPieces.toString(), 'center'),
            this.getRowFormat(grandTotal, 'center', false, true)
          ];
          data.push(tableRow);
        });

        product.productAttributes.forEach(attribute => {
          if (attribute.displayPrices.costPerPiece <= 0) {
            return;
          }

          const costPerPieceContainer = this.formatPrice(attribute.displayPrices.costPerPiece);
          const costPerPieceDiscountContainer = this.formatPrice(attribute.displayPrices.costPerPieceDiscount);
          const total = this.formatPrice(attribute.displayPrices.costPerPieceDiscount * attribute.quantity);

          const tableRowContainer = [
            this.getRowFormat(recipePatient, 'left', true),
            this.getRowFormat(attribute.itemCode),
            this.getRowFormat(attribute.container),
            this.getRowFormat(costPerPieceContainer, 'center'),
            this.getRowFormat(costPerPieceDiscountContainer, 'center'),
            this.getRowFormat(attribute.quantity.toString(), 'center'),
            this.getRowFormat(total, 'center', false, true)
          ];
          data.push(tableRowContainer);
        });
      });
    });

    return data;
  }

  groupBy(attributes: ProductAttributes[]): Record<string, ProductAttributes[]> {
    return attributes.reduce((acc, attribute) => {
      if (!acc[attribute.costPerPieceDiscount]) {
        acc[attribute.costPerPieceDiscount] = [];
      }

      acc[attribute.costPerPieceDiscount].push(attribute);
      return acc;
    }, {} as Record<string, ProductAttributes[]>);
  }

  getRowFormat(message: string, alignment: Alignment = 'left', borderLeft = false, borderRight = false): TableCell {
    return {
      text: message,
      alignment,
      border: [borderLeft, false, borderRight, true]
    };
  }
}
